import type { SerRun } from '../api/knowledgeApi'

/** finishedAt is the append-only progress heartbeat while the upstream status is running. */
export function resolutionStatus(run: SerRun, now = Date.now()): string {
  if (run.status !== 'running') return run.status || 'unknown'
  const heartbeat = Date.parse(run.finishedAt || run.startedAt || '')
  return !Number.isFinite(heartbeat) || now - heartbeat > 45 * 60_000 ? 'stale' : 'running'
}
